<template>
  <div :class="`c-mobile-utility-nav${isNew ? '-new' : ''}`">
    <slot
      v-if="hasSearchSlot"
      name="mobile-search"
    />
    <nuxt-link
      v-else
      :class="`c-mobile-utility-nav${isNew ? '-new' : ''}__link t-heading-6`"
      to="/search"
    >
      Search
    </nuxt-link>
    <a
      :href="accountUrl"
      :class="`c-mobile-utility-nav${isNew ? '-new' : ''}__link t-heading-6`"
    >
      My Account
    </a>
    <nuxt-link
      to="/pages/faq"
      :class="`c-mobile-utility-nav${isNew ? '-new' : ''}__link t-heading-6`"
    >
      <title>FAQ</title>
      FAQ
    </nuxt-link>
  </div>
</template>

<script>
export default {
  name: "MobileUtilityNav",
  props:{
    isNew: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hasSearchSlot() {
      const slots = this.$slots
      return !!(slots && slots['mobile-search'])
    },
    accountUrl() {
      return process.env.ACCOUNT_URL || '/account'
    }
  }
}
</script>
<style lang="scss" scoped>
  .c-mobile-utility-nav{
    @include themify($themes){
      border-bottom: $border themed("foreground", "light");
    }
    padding: $filter-padding;

    &__link{
      @include themify($themes) {
        color: themed("primary", "base");
      }
      display: block;
      margin-bottom: rem(15px);
      text-decoration: none;
      &:hover{
        @include themify($themes) {
          color: themed("accent", "base");
        }
      }

      svg{
        margin-right: rem(20px);
        position: relative;
        top: 3px;
      }
    }
  }
  .c-mobile-utility-nav-new{
    padding: $filter-padding;
    padding-top: 3.5rem;
    padding-bottom: 0;

    &__link{
      @include themify($themes) {
        color: themed("primary", "base");
      }
      display: block;
      margin-bottom: rem(15px);
      text-decoration: none;
      &:hover{
        @include themify($themes) {
          color: themed("accent", "base");
        }
      }
      &:last-child {
        margin-bottom: rem(6px);
      }

      svg{
        margin-right: rem(20px);
        position: relative;
        top: 3px;
      }
    }
  }
</style>
